<template>
  <div class="feedback-container">
    <div class="feedback-content">
      <h2>Contact Us</h2>
      <PropertyInput
        :title="'Your name'"
        :propName="'name'"
        :placeholder="'John Doe'"
        :getValue="this.getValue"
        :setValue="this.setValue"
        :validationError="getValidationErrorForField('name')"
      />
      <PropertyInput
        :title="'Your e-mail address'"
        :propName="'email'"
        :placeholder="'john.doe@email.com'"
        :getValue="this.getValue"
        :setValue="this.setValue"
        :required="false"
        :validationError="getValidationErrorForField('email')"
      />
      <TextInput
        :title="'Feedback'"
        :propName="'description'"
        :placeholder="'To allow improving the service, please provide details. E.g. identifying the flight, actual behavior compared to what you expected. Thank you!'"
        :getValue="this.getValue"
        :setValue="this.setValue"
        :validationError="getValidationErrorForField('description')"
      />
      <div class="submit-button">
        <vue-recaptcha
          v-if="this.validationErrors.length === 0 && this.recaptchaEnabled"
          ref="recaptcha"
          sitekey="6LfPPMEZAAAAAMp3cvY0qOB3GgmIjdA2fOrLELoN"
          @verify="submitFeedback"
        >
          <button
            disabled
            type="submit"
            class="btn btn-primary"
          >Submit</button>
        </vue-recaptcha>
        <button
          v-else
          :disabled="this.validationErrors.length !== 0"
          type="button"
          class="btn btn-primary"
          @click="submitFeedback"
        >Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import A from "../../constants/actions";
import AppConfig from "../../config/appConfig";
import DialogUtils from "../../utils/DialogUtils";
import PopupUtils from "../../utils/PopupUtils";
import LoggerUtils from "../../utils/LoggerUtils";
import PropertyInput from "../common/PropertyInput.vue";
import FeedbackService from "../../services/feedbackService";
import VueRecaptcha from "vue-recaptcha";
import TextInput from "../common/TextInput";

export default {
  name: "Feedback",
  components: {
    PropertyInput,
    TextInput,
    VueRecaptcha,
  },
  computed: {
    feedback() {
      return this.$store.state.feedbackStore.feedback;
    },
    validationErrors() {
      return this.validateFields(this.feedback);
    },
    recaptchaEnabled() {
      return AppConfig.recaptcha;
    },
  },
  methods: {
    getValue(propName) {
      return this.feedback[propName];
    },
    setValue(name, value) {
      this.$store.dispatch(A.FEEDBACK_UPDATE_PROPERTY, { name, value });
    },
    getValidationErrorForField(field) {
      const error = this.validationErrors.find(
        (error) => error.field === field
      );
      return error ? error.error : null;
    },
    validateFields(feedback) {
      const errors = [];

      if (feedback.name === "") {
        errors.push({
          field: "name",
          error: "Name is mandatory",
        });
      }

      if (feedback.description === "") {
        errors.push({
          field: "description",
          error: "Description is mandatory",
        });
      }

      return errors;
    },
    submitFeedback() {
      const self = this;
      if (self.$refs.recaptcha != null) {
        self.$refs.recaptcha.reset();
      }

      FeedbackService.createFeedback({
        data: this.$store.state.feedbackStore.feedback,
        onSuccess: () => {
          const message = "Feedback provided. Thank you!";
          LoggerUtils.info(message);
          PopupUtils.success(message);
        },
        onError: (error) => {
          console.log(error);
          const message = "An error has occurred while providing feedback!";
          LoggerUtils.error(message);
          DialogUtils.errorNotification(message);
        },
      });
    },
  },
};
</script>

<style src="./feedback.css"></style>